import type { InvoiceData } from "@/types";
import { formatDateWithOptionsBs } from "@/lib/format";

function fmtKm(n: number): string {
  return `${new Intl.NumberFormat("bs-BA", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(n)} KM`;
}

function fmtDate(s: string): string {
  return formatDateWithOptionsBs(s, {
    day: "numeric",
    month: "long",
    year: "numeric",
    timeZone: "Europe/Sarajevo",
  });
}

// Potvrda o dopuni kredita za STARE dopune, upisane prije nego što je uz svaku
// dopunu počela da se izdaje FAK faktura (company_credit_transactions.invoiceId
// je NULL). Nije fiskalni dokument, pa se ne zove "Račun"; dopune sa fakturom
// vode na PDF fakture.
export function openInvoiceReceipt(invoice: InvoiceData): void {
  const { company, transaction } = invoice;
  const issued = fmtDate(transaction.createdAt);

  const html = `<!DOCTYPE html>
<html><head><meta charset="utf-8"><title>Potvrda o dopuni kredita - ${company.name} - ${issued}</title>
<style>
*{margin:0;padding:0;box-sizing:border-box}
body{font-family:'Segoe UI',system-ui,sans-serif;color:#1a1a1a;padding:40px;max-width:800px;margin:0 auto}
.header{display:flex;justify-content:space-between;align-items:flex-start;margin-bottom:40px;padding-bottom:20px;border-bottom:2px solid #e5e5e5}
.header h1{font-size:24px;font-weight:700}
.header .period{font-size:14px;color:#666;margin-top:4px}
.header .right{font-size:14px;color:#666;text-align:right}
.info-grid{display:grid;grid-template-columns:1fr 1fr;gap:24px;margin-bottom:32px}
.info-box h3{font-size:11px;text-transform:uppercase;letter-spacing:1px;color:#999;margin-bottom:8px}
.info-box p{font-size:13px;line-height:1.6}
.total{display:flex;justify-content:flex-end;padding:16px 0;border-top:2px solid #1a1a1a;margin-top:8px}
.total .label{font-size:14px;font-weight:600;margin-right:24px}
.total .amount{font-size:20px;font-weight:700}
.footer{margin-top:40px;padding-top:16px;border-top:1px solid #e5e5e5;font-size:11px;color:#999;text-align:center}
@media print{body{padding:20px}}
</style></head><body>
<div class="header"><div><h1>${company.name}</h1><p class="period">Dopuna kredita · ${issued}</p></div>
<div class="right"><p>POTVRDA O DOPUNI KREDITA</p><p style="font-size:13px;color:#999;margin-top:4px">Datum: ${issued}</p></div></div>
<div class="info-grid"><div class="info-box"><h3>Firma</h3><p><strong>${company.name}</strong></p><p>Plan: ${company.planType}</p><p>Email: ${company.billingEmail}</p></div>
<div class="info-box"><h3>Dopuna</h3><p>Stanje nakon dopune: ${fmtKm(transaction.balanceAfter)}</p>${transaction.adminName ? `<p>Obradio: ${transaction.adminName}</p>` : ""}${transaction.note ? `<p>Napomena: ${transaction.note}</p>` : ""}</div></div>
<div class="total"><span class="label">Iznos dopune:</span><span class="amount">${fmtKm(transaction.amount)}</span></div>
<div class="footer">Ova potvrda nije fiskalni račun. Generisano putem Psihotron platforme · ${issued}</div>
</body></html>`;

  const blob = new Blob([html], { type: "text/html" });
  const url = URL.createObjectURL(blob);
  const w = window.open(url, "_blank");
  if (w) {
    w.onload = () => {
      w.print();
      URL.revokeObjectURL(url);
    };
  } else {
    const a = document.createElement("a");
    a.href = url;
    a.download = `potvrda-dopune-${company.name.toLowerCase().replace(/\s+/g, "-")}-${transaction.id}.html`;
    a.click();
    URL.revokeObjectURL(url);
  }
}
